import { Divider, Typography } from '@mui/material';
import { useDirectoryModel, useNoteAuthorLookup } from '../Model/DirectoryModel';
import { UpdateDialog } from '../Generic/UpdateDialog';
import { Note } from '../GeneratedClient';
import { PersonName } from '../Families/PersonName';
import { format } from 'date-fns';

interface ApproveNoteDialogProps {
  familyId: string;
  note: Note;
  onClose: () => void;
}

export function ApproveNoteDialog({
  familyId,
  note,
  onClose,
}: ApproveNoteDialogProps) {
  const directoryModel = useDirectoryModel();
  const noteAuthorLookup = useNoteAuthorLookup();

  async function approve() {
    await directoryModel.approveNote(
      familyId,
      note.id!,
      note.contents!,
      note.backdatedTimestampUtc,
      note.accessLevel
    );
  }

  return (
    <UpdateDialog
      title="Do you want to approve and finalize this note?"
      onClose={onClose}
      onSave={approve}
    >
      <Typography variant="body2" component="p">
        <PersonName person={noteAuthorLookup(note)} /> -&nbsp;
        {format(note.lastEditTimestampUtc, 'MM/dd/yyyy hh:mm aa')}
      </Typography>
      {note.backdatedTimestampUtc && (
        <Typography variant="body2" component="p">
          Backdated to:{' '}
          {format(note.backdatedTimestampUtc!, 'MM/dd/yyyy hh:mm aa')}
        </Typography>
      )}
      <Divider />
      <Typography>{note.contents}</Typography>
    </UpdateDialog>
  );
}
